export default {"src":"/_next/static/image/public/images/ic_location_blue_vertical_menu.f4c403523e94753db5af8119a530dd15.svg","height":20,"width":20};